export default __webpack_public_path__ + "static/dont-overuse-images-3c3e2b26efc091a03fd7a9c9f77d65e8.png";